import styled from 'styled-components';

export const Style = styled.div`
  .flex-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .flex-1 { flex: 1; }

  .main-cont {
    min-height: 100%;
    display: flex;
    flex-direction: column;

    .project-header {
      margin-left: -24px;
      margin-right: -24px;
      display: flex;
      z-index: 2;
      flex-direction: column;
      gap: 10px;
      background: white;
      padding: 20px 22px;
      border-bottom: 1px solid #EAECF0;
      position: sticky;
      top: 0px;

      h1 {
        font-size: 20px;
        margin-bottom: 0px;
        font-weight: 600;
      }
    }

    .subject-body {
      padding: var(--size-lg) var(--size-lg);
      display: grid;
      grid-gap: var(--size-lg);
      grid-template-columns: 1fr 1fr;

      .item {
        padding: var(--size-lg);
        background: #FFFFFF;
        box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
        border-radius: 4px;
        margin-bottom: 0px;

        .logos {
          display: flex;
          gap: 5px;

          img {
            height: 11px;
          }
        }

        .item-header { 
          display: flex;
          margin-bottom: var(--size);

          label {
            font-size: var(--font-size-lg);
            font-weight: 600;
            margin-bottom: 0px;
          }
        }

        .info {
          display: flex;
          flex-direction: column;
          gap: 5px;

          .row-item {
            display: flex;

            label {
              font-size: 14px;
              margin-bottom: 0px;
              font-weight: 500;
            }

            .left {
              flex: 1;

              label {
                color: #98A2B3;
              }
            }

            .right {
              flex: 1;
              display: flex;
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }
`;
